module.exports = __webpack_public_path__ + "static/media/GalwaysLand.36abd859.png";